import { render, staticRenderFns } from "./Sitedown.vue?vue&type=template&id=54a172d4"
import script from "./Sitedown.vue?vue&type=script&lang=js"
export * from "./Sitedown.vue?vue&type=script&lang=js"
import style0 from "./Sitedown.vue?vue&type=style&index=0&id=54a172d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports